jQuery(document).ready(async function ($) {
  const $input = $('.t4s-mini-search__input-custom');
  const $popover = $(".t4s-mini-search__content");
  const $typeSelect = $("select.t4s-truncate");

  let products = [];

  (async () => {
    try {
      const totalPages = 10;
      const fetchPromises = [];

      for (let page = 1; page <= totalPages; page++) {
        let url = `/pages/product-json?page=${page}`;
        if (document.documentElement.lang === "en") {
          url = `/en/pages/product-json?page=${page}`;
        }
        fetchPromises.push(fetch(url).then(res => res.json()));
      }

      const results = await Promise.all(fetchPromises);
      products = results.flatMap(data => data);
    } catch (err) {
      console.error("Error:", err);
    }
  })();

  function normalizeString(str) {
    return str
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function getOrderedMatchPosition(text, words) {
    let lastIndex = -1;
    for (let word of words) {
      const index = text.indexOf(word, lastIndex + 1);
      if (index === -1) return Infinity;
      lastIndex = index;
    }
    return lastIndex;
  }

 function smartSearch(keyword, items) {
  keyword = normalizeString(keyword);
  const words = keyword.split(/\s+/);

  let results = items.filter(product =>
    normalizeString(product.title).includes(keyword)
  );

  if (results.length === 0) {
    results = items.filter(product => {
      const title = normalizeString(product.title);
      return getOrderedMatchPosition(title, words) !== Infinity;
    });
  }


  if (results.length === 0) {
    if (keyword.length >= 5) {
      let variantMatches = [];

      items.forEach(product => {
        if (product.variants && product.variants.length > 0) {
          product.variants.forEach(variant => {
            const ref = normalizeString(variant.sku || "");

            if (ref.includes(keyword)) {
              variantMatches.push({
                ...product,                   
                price: variant.price,          
                images: [{ src: variant.image }],
                handle: product.handle,
                reference_found: variant.sku,
                variant_id: variant.id,
                _isVariant: true 
              });
            }
          });

        }
      });

      if (variantMatches.length > 0) return variantMatches;
    }else{
      // results = items.filter(product => {
      //   const productSKU = normalizeString(product.sku || "");
      //   return productSKU.includes(keyword);
      // });

      results = items.filter(product => {
          const productSKU = normalizeString(product.sku || "");
          const variantMatch = (product.variants || []).some(v =>
              normalizeString(v.sku || "").includes(keyword)
          );

          if (productSKU && productSKU.includes(keyword)) return true;

          if (variantMatch) return true;

          return false;
      });
    } 
  }


  results.sort((a, b) => {
    const titleA = normalizeString(a.title);
    const titleB = normalizeString(b.title);

    const fullMatchA = titleA.indexOf(keyword);
    const fullMatchB = titleB.indexOf(keyword);
    if (fullMatchA !== fullMatchB) return fullMatchA - fullMatchB;

    const posA = getOrderedMatchPosition(titleA, words);
    const posB = getOrderedMatchPosition(titleB, words);
    if (posA !== posB) return posA - posB;

    return titleA.length - titleB.length;
  });

  return results;
}

  function formatPrice(price) {
    const newPrice = Math.round(price / 100);
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(newPrice);
  }

  function applyFilters(products) {
    let filtered = [...products];
    const selectedType = $(".t4s-mini-search__cat select").val();

    if (selectedType !== "*" && selectedType !== "") {
      filtered = filtered.filter(p =>
        p.product_type &&
        p.product_type.toLowerCase().trim() === selectedType.toLowerCase().trim()
      );
    }

    return filtered;
  }

  $('body').on('click', '.t4s-mini-search__viewAll', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.t4s-mini-search__frm').submit();
  });

  $('body').on('keyup', '.t4s-mini-search__input', function (e) {
    if (e.key === "Enter") {
      $(this).closest('form').submit();
    }

    const keyword = $(this).val().trim();
    const matched = smartSearch(keyword, products);
    const filtered = applyFilters(matched);

    if (keyword.length < 1) {
      $(".t4s-drawer__bottom").hide();
    } else {
      $(".t4s-drawer__bottom").html(`
        <a href="#" class="t4s-mini-search__viewAll t4s-d-block" tabindex="-1">
          Search for “${keyword}”
          <svg width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M 18.71875 6.78125 L 17.28125 8.21875 L 24.0625 15 L 4 15 L 4 17 L 24.0625 17 L 17.28125 23.78125 L 18.71875 25.21875 L 27.21875 16.71875 L 27.90625 16 L 27.21875 15.28125 Z"></path>
          </svg>
        </a>
      `);
      $(".t4s-drawer__bottom").show();
    }

    $('#t4s-search-hidden.t4s-search-sidebar .t4s-mini-search__title')
      .text('Search results')
      .show();

    if (filtered.length === 0) {
      $('.t4s-mini-search__content').html(`
        <span class='t4s-search-empty-note t4s-text-center'>
          No products were found matching your selection.
        </span>
      `);
    } else {
       if (keyword.length != 0) {
          const html = filtered.slice(0, 15).map(product => {
          const firstImage = product.images?.[0]?.src ||
            "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_medium.png";
          const price = product.price;
          const compareAtPrice = product.discount_price;
          let url_product = `/products/${product.handle}`;

          if (product._isVariant && product.variant_id) {
            url_product = `/products/${product.handle}?variant=${product.variant_id}`;
          }

          if (document.documentElement.lang === "en") {
            url_product = `/en/products/${product.handle}`;

            if (product._isVariant && product.variant_id) {
              url_product = `/en/products/${product.handle}?variant=${product.variant_id}`;
            }
          }
          return `
            <div class="t4s-row t4s-space-item-inner t4s-widget__pr">
              <div class="t4s-col-item t4s-col t4s-widget_img_pr aa2">
                <a class="t4s-d-block t4s-pr t4s-oh t4s_ratio t4s-bg-11 t4s-child-lazyloaded"
                  href="${url_product}"
                  style="background: url(${firstImage}); --aspect-ratioapt: 1.0">
                  <img
                    class="lazyautosizes ls-is-cached lazyloadt4sed"
                    data-widths="[100,200,400,600,700]"
                    data-optimumx="2"
                    data-sizes="auto"
                    width="600"
                    height="600"
                    alt="${product.title}"
                    srcset="${firstImage} 100w, ${firstImage} 200w, ${firstImage} 400w, ${firstImage} 600w, ${firstImage} 700w"
                    sizes="78px"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  />
                </a>
              </div>
              <div class="t4s-col-item t4s-col t4s-widget_if_pr ${url_product}">
                <a href="${url_product}" class="t4s-d-block t4s-widget__pr-title">
                  ${product.title}
                </a>
                <div class="a2 t4s-widget__pr-price" data-pr-price="">
                  ${
                    compareAtPrice && compareAtPrice < price
                      ? `
                        <span class="original-price" style="text-decoration: line-through; color: #333;">
                          <span class="notranslate ht-money">${formatPrice(price)}</span>
                        </span>
                        <span class="discounted-price" style="color: #e74c3c; margin-left: 5px;">
                          <span class="notranslate ht-money">${formatPrice(compareAtPrice)}</span>
                        </span>
                      `
                      : `
                        <span class="discounted-price">
                          <span class="notranslate ht-money">${formatPrice(price)}</span>
                        </span>
                      `
                  }
                </div>
              </div>
            </div>
          `;
        }).join("");

        $('.t4s-mini-search__content').html(html);
      }else{
        $('.t4s-mini-search__content').html('');
      }
    }

    $('.t4s-mini-search__content').show();
  });

  $('body').on('change', '.t4s-mini-search__cat select', function () {
    const keyword = $('.t4s-mini-search__input').val().trim();
    const matched = smartSearch(keyword, products);
    const filtered = applyFilters(matched);

    if (keyword.length < 1) {
      $(".t4s-drawer__bottom").hide();
    } else {
      $(".t4s-drawer__bottom").html(`
        <a href="#" class="t4s-mini-search__viewAll t4s-d-block" tabindex="-1">
          Search for “${keyword}”
          <svg width="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M 18.71875 6.78125 L 17.28125 8.21875 L 24.0625 15 L 4 15 L 4 17 L 24.0625 17 L 17.28125 23.78125 L 18.71875 25.21875 L 27.21875 16.71875 L 27.90625 16 L 27.21875 15.28125 Z"></path>
          </svg>
        </a>
      `);
      $(".t4s-drawer__bottom").show();
    }

    $('#t4s-search-hidden.t4s-search-sidebar .t4s-mini-search__title')
      .text('Search results')
      .show();

    if (filtered.length === 0) {
      $('.t4s-mini-search__content').html(`
        <span class='t4s-search-empty-note t4s-text-center'>
          No products were found matching your selection.
        </span>
      `);
    } else {
      if (keyword.length != 0) {
          const html = filtered.slice(0, 15).map(product => {
          const firstImage = product.images?.[0]?.src ||
            "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_medium.png";
          const price = product.price;
          const compareAtPrice = product.discount_price;
          let url_product = `/products/${product.handle}`;
          
          if (product._isVariant && product.variant_id) {
            url_product = `/products/${product.handle}?variant=${product.variant_id}`;
          }

          if (document.documentElement.lang === "en") {
            url_product = `/en/products/${product.handle}`;

            if (product._isVariant && product.variant_id) {
              url_product = `/en/products/${product.handle}?variant=${product.variant_id}`;
            }
          }
          return `
            <div class="t4s-row t4s-space-item-inner t4s-widget__pr">
              <div class="t4s-col-item t4s-col t4s-widget_img_pr aa2">
                <a class="t4s-d-block t4s-pr t4s-oh t4s_ratio t4s-bg-11 t4s-child-lazyloaded"
                  href="${url_product}"
                  style="background: url(${firstImage}); --aspect-ratioapt: 1.0">
                  <img
                    class="lazyautosizes ls-is-cached lazyloadt4sed"
                    data-widths="[100,200,400,600,700]"
                    data-optimumx="2"
                    data-sizes="auto"
                    width="600"
                    height="600"
                    alt="${product.title}"
                    srcset="${firstImage} 100w, ${firstImage} 200w, ${firstImage} 400w, ${firstImage} 600w, ${firstImage} 700w"
                    sizes="78px"
                    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  />
                </a>
              </div>
              <div class="t4s-col-item t4s-col t4s-widget_if_pr ${url_product}">
                <a href="${url_product}" class="t4s-d-block t4s-widget__pr-title">
                  ${product.title}
                </a>
                <div class="a2 t4s-widget__pr-price" data-pr-price="">
                  ${
                    compareAtPrice && compareAtPrice < price
                      ? `
                        <span class="original-price" style="text-decoration: line-through; color: #333;">
                          <span class="notranslate ht-money">${formatPrice(price)}</span>
                        </span>
                        <span class="discounted-price" style="color: #e74c3c; margin-left: 5px;">
                          <span class="notranslate ht-money">${formatPrice(compareAtPrice)}</span>
                        </span>
                      `
                      : `
                        <span class="discounted-price">
                          <span class="notranslate ht-money">${formatPrice(price)}</span>
                        </span>
                      `
                  }
                </div>
              </div>
            </div>
          `;
        }).join("");

        $('.t4s-mini-search__content').html(html);
      }else{
        $('.t4s-mini-search__content').html('');
      }
    }

    $('.t4s-mini-search__content').show();
  });
});
